import * as React from 'react'

import { TaskStatusWrapper } from '@/modules/shared/components'

import DividerVertical from '@/modules/drivers/shared/DividerVertical'
import {
  faBellPlusSolid,
  faCalendarClockSolid,
  FaIcon,
  faPrintSolid,
} from '@/lib/fa'
import usePrint from '../../hooks/usePrint'
import { useTimetable } from '@/modules/timetable/stores/timetableStore'
import Tooltip from '@/modules/drivers/shared/ToolTip'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { withRouter, RouteComponentProps } from '@/app/navigation/withRouter'

type TimetableViewControlBarProps = RouteComponentProps<{
  companyId: string
  from?: string
  to?: string
}>

const TimetableViewControlBar: React.FC<TimetableViewControlBarProps> = ({
  match,
}) => {
  const { params } = match
  const companyId = params.companyId as string
  const {
    showOnlyUpComing,
    setShowOnlyUpComing,
    amount,
    showAddAlert,
    setShowAddAlert,
    canEditAlerts,
  } = useTimetable()
  const { t } = useLocalize()
  const [open, setOpen] = React.useState(false)

  const containerRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!open) {
      return undefined
    }
    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open])

  const { handlePrintConfirm, isGenerating, busyTooltip } = usePrint({
    companyId,
  })
  return (
    <TaskStatusWrapper>
      <div className="tw-flex tw-z-[100] tw-items-center tw-gap-4 tw-bg-[#FAFBFF] tw-px-4 tw-py-3.5">
        <div className="tw-flex tw-items-center tw-gap-2">
          <strong>{amount}</strong>
          <p className="tw-text-sm tw-text-content-base">{t('alerts.alerts-count-label')}</p>
        </div>
        <DividerVertical />
        {/* <div className="tw-grid tw-h-5 tw-w-5 tw-cursor-pointer tw-place-items-center tw-rounded tw-bg-[#6B77A0]/30">
          <FaIcon icon={faEyeSolid} className="tw-h-4 tw-w-4 tw-text-white" />
        </div> */}
        <Tooltip
          text={t('alerts.show-upcoming-only')}
          onClick={() => setShowOnlyUpComing((prev) => !prev)}
          className={`tw-grid tw-h-5 tw-w-5 tw-cursor-pointer tw-place-items-center tw-rounded ${showOnlyUpComing ? 'tw-bg-primary' : 'tw-bg-[#6B77A0]/30'}`}
        >
          <FaIcon
            icon={faCalendarClockSolid}
            className="tw-h-4 tw-w-4 tw-text-white"
          />
        </Tooltip>
        <DividerVertical />
        <div
          title={busyTooltip}
          className={`tw-flex tw-items-center tw-gap-2 ${
            isGenerating
              ? 'tw-cursor-not-allowed tw-opacity-50'
              : 'tw-cursor-pointer'
          }`}
          onClick={() =>
            !isGenerating && handlePrintConfirm({ selected: false })
          }
        >
          <FaIcon icon={faPrintSolid} className="tw-text-primary" />
          <p className="tw-text-sm tw-font-semibold tw-text-primary">{t('common.print')}</p>
        </div>
        <DividerVertical />
        <div
          className={`tw-flex tw-items-center tw-gap-2 ${canEditAlerts ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed tw-pointer-events-none tw-opacity-50'}`}
          onClick={() => {
            // if (canEditAlerts) {
              setShowAddAlert(true)
            // }
          }}
        >
          <FaIcon icon={faBellPlusSolid} className="tw-text-primary" />
          <p className="tw-text-sm tw-font-semibold tw-text-primary">
            {t('alerts.add-new')}
          </p>
        </div>
      </div>
    </TaskStatusWrapper>
  )
}

export default withRouter(TimetableViewControlBar)
